import * as React from "react";
import { singleton } from "logic/singleton";
const RetrievalContext = React.createContext(void 0);
export default singleton("contexts.RetrievalContext", () => RetrievalContext);
